import type { I18nKey } from "~/i18n";
import type { VoiceTranscriptionFailure } from "~/voiceTranscription";
import { MESSAGE_BY_KIND } from "./inferenceFailureMessages";

export interface VoiceTranscriptionFailureToast {
  readonly type: "error" | "warning";
  readonly title: I18nKey;
  readonly description: I18nKey | null;
}

const COULD_NOT_TRANSCRIBE = "chat/couldNotTranscribeThe_y2yq77";
const TRY_AGAIN = "chat/tryAgain_6zsnzo";
const OUTAGE = "chat/theTranscriptionServiceIs_hm21ko";

/**
 * What the lawyer is told when a kept recording produced no text. An absent
 * transcription provider («не подключён») and a configured one that failed
 * («временно недоступен») read differently, since only the second is worth
 * retrying soon.
 */
export function describeVoiceTranscriptionFailure(
  failure: VoiceTranscriptionFailure | null,
): VoiceTranscriptionFailureToast {
  const couldNotTranscribe = (description: I18nKey | null): VoiceTranscriptionFailureToast => ({
    type: "error",
    title: COULD_NOT_TRANSCRIBE,
    description,
  });
  switch (failure?.kind) {
    case "tooLong":
      return {
        type: "warning",
        title: "chat/recordingStopped_03djob",
        description: "chat/recordingsAreLimitedTo_crscla",
      };
    case "voiceInputDisabled":
      return couldNotTranscribe("chat/voiceInputIsDisabled_t2q77p");
    case "notConfigured":
      return {
        type: "error",
        title: "chat/voiceInputIsNot_01i1mw",
        description: "chat/theRecordingIsKept_u6zrrb",
      };
    case "tooLarge":
      return couldNotTranscribe("chat/theRecordingIsToo_zsammr");
    case "unavailable":
      return couldNotTranscribe(
        failure.inferenceFailure === null ? OUTAGE : MESSAGE_BY_KIND[failure.inferenceFailure],
      );
    case "network":
    case "timeout":
    case "invalidResponse":
      return couldNotTranscribe(OUTAGE);
    case "unauthorized":
      return couldNotTranscribe(
        failure.status === 403 ? "environments/thisOperationIsNot_grkdt6" : TRY_AGAIN,
      );
    default:
      return couldNotTranscribe(TRY_AGAIN);
  }
}
